import { reverse } from 'named-urls'
import { useMatch, useNavigate } from 'react-router-dom'

import { ConfirmModal, useModalContext } from '@fourthwall/components'

import { routing } from '../../../utils/routing'
import { useThemeLivePreviewContext } from '../modules/LivePreview/providers/ThemeLivePreviewProvider'
import { useDirtyContext } from '../providers/DirtyProvider'
import { usePageLayoutContext } from '../providers/PageLayoutProvider'
import { useCurrentShopContext } from './useCurrentShopContext'
import { useRemoveSectionMutation } from './useRemoveSectionMutation'
import { useThemeEditorContext } from './useThemeEditorContext'

export const useRemoveSection = () => {
  const { currentPageId } = useThemeEditorContext()
  const { setIsDirty } = useDirtyContext()
  const { currentShop } = useCurrentShopContext()
  const { pageLayoutQuery } = usePageLayoutContext()
  const { channel, setInspectorVisible } = useThemeLivePreviewContext()

  const { removeSectionMutation } = useRemoveSectionMutation()
  const matchesSectionPage = useMatch(routing.themeEditorV2.layout.page.sections)
  const navigate = useNavigate()
  const { open } = useModalContext()

  const removeSection = (sectionKey?: string) => {
    const section = pageLayoutQuery.data?.sectionsGroups
      .flatMap((block) => block.sections)
      .find((section) => section.sectionKey === sectionKey)

    setInspectorVisible(false)

    if (!section || !currentPageId || !sectionKey) {
      throw new Error('removeSection: Missing section or current page ID')
    }

    open(ConfirmModal, {
      title: 'Are you sure you want to delete this section?',
      confirmLabel: 'Delete',
      confirmAppearance: 'destructive',
      onConfirm: () => {
        setInspectorVisible(false)

        channel.emit({
          action: 'ThemePreview:RemoveSection',
          payload: { id: sectionKey },
        })

        setIsDirty(true)

        removeSectionMutation.mutate(
          [
            {
              shop_id: currentShop.id,
              draft_section_id: section.id,
            },
          ],
          {
            onSuccess: () => {
              pageLayoutQuery.refetch()
              if (matchesSectionPage) {
                navigate(reverse(routing.themeEditorV2.layout.page.self, { pageId: currentPageId }))
              }
            },
          },
        )
      },
    })
  }

  return {
    removeSection,
  }
}
